import React, { useEffect, useRef, useState } from 'react';
import Header from '../../../components/header';
import Layout from '../../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../components/icons';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import { PAGE_SIZE } from '../../../_common/constant';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Loader from '../../../components/loader';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { titleCell } from '../../../components/elements/function';

import toast from 'react-hot-toast';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import CreateMasterFacility from './CreateMasterFacility';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';

const MasterFacility: React.FC = () => {
    const createDrawerRef: any = useRef();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [rowData, setRowData] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('userFacilityFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('userFacilityFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const addNewFacilityRef: any = React.createRef<HTMLButtonElement>();
    const createFacilityRef: any = useRef();

    const filterConfig: filterConfigType[] = [
        { name: 'First Name', type: 'text', key: 'firstName' },
        { name: 'Last Name', type: 'text', key: 'lastName' },
        { name: 'Email', type: 'text', key: 'email' },
    ];

    const { confirm } = useDialog();
    const facilityApi: any = useFacilitiesApi();

    const onGridReady = (params: any) => {
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const columnDefs = [
        { headerName: 'Name', field: 'name', headerClass: 'bg-[#f0f0f0]', width: 450, cellRenderer: titleCell },
        { headerName: 'Phone Number', field: 'phone', headerClass: 'bg-[#f0f0f0]', width: 350 },
        { headerName: 'Email ID', field: 'emailID', headerClass: 'bg-[#f0f0f0]', minWidth: 350, flex: 1 },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,
            pinned: 'right',
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                let action = e.target.value;
                                handleActionChange(e, params);
                                //e.target.value = '';
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            <option value="delete">Delete</option>

                        </select>
                    </div>
                );
            },

        }
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                setEditData(rowData);
                addNewFacilityRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete Facility Manager',
                    message: 'Are you sure you want to delete this Facility Manager?',
                    onConfirm: () => {
                        facilityApi.deleteFacilityManager(
                            { facilityManagerMasterId: rowData.facilityManagerMasterId },
                            (resp: any) => {
                                toast.success('Facility Manager deleted successfully');
                                getUserFacilityList();
                            },
                            (error: any) => {
                                console.error('Error deleting facility manager:', error);
                                toast.error('Failed to delete Facility Manager');
                            }
                        );
                    }
                });
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getUserFacilityList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }

        setRowData(null);

        facilityApi.getFacilityManagerList(
            payload,
            (resp: any) => {
                if (resp && resp.facilityList) {
                    setRowData(resp.facilityList);
                    setTotalRecords(resp.totalRecords || resp.facilityList.length);
                } else {
                    setRowData([]);
                    setTotalRecords(0);
                }
            },
            (error: any) => {
                console.error('Error fetching facility manager list:', error);
                toast.error('Failed to load facility manager list');
                setRowData([]);
                setTotalRecords(0);
            }
        );
    };

    // Call getUserFacilityList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getUserFacilityList();
        }

        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters, filtersInitialized]);

    return (
        <Layout>
            <Header title="Facility Manager List" back="/settings" >
                <Header.Right>
                    <Drawer _ref={addNewFacilityRef} onClose={() => {
                        setEditData(null);
                        createFacilityRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Create'} Master Facility</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Master Facility' : 'New Master Facility'} className='!w-[39.563rem]'>
                            <CreateMasterFacility _ref={createFacilityRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                getUserFacilityList();
                                addNewFacilityRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewFacilityRef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} placeholder='Search by name or email'/> */}
            </div>
            <div className='bg-[#FAFAFA] w-full'>
                {/* <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('userFacilityFilters');
                        setFiltersApplied({ generalFilter: false });
                        setCurrentPage(1);
                    }} >Clear Filters</p>
                </div> */}
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default MasterFacility;